import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { node } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Link from '../../atoms/Link';

const ToolbarItem = _ref => {
  let {
    children,
    endIcon,
    startIcon
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "endIcon", "startIcon"]);

  const buildIcon = icon => icon && typeof icon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : icon;

  return /*#__PURE__*/React.createElement(Link, _extends({
    "data-testid": "toolbar-item"
  }, props), buildIcon(startIcon), children, buildIcon(endIcon));
};

process.env.NODE_ENV !== "production" ? ToolbarItem.propTypes = {
  children: node,
  endIcon: node,
  startIcon: node
} : void 0;
ToolbarItem.defaultProps = {
  children: null,
  color: 'inherit',
  underlineOnHover: false,
  fontSize: 1,
  fontWeight: 'medium',
  gap: 1
};
export default ToolbarItem;